<template>
    <v-card style="border-radius: 1em;">
        <v-btn icon @click="$emit('fechar')"><v-icon>close</v-icon></v-btn>
        <template v-if="solicitacao.cliente">
            <v-card-text>
                <v-layout fill-height wrap class="mb-3 subheading font-weight-regula" v-if="solicitacao">
                    <v-flex xs12 class="mb-2">
                        <h1 class="mt-2 mb-2 text-xs-center primary--text">Retirada de valor</h1>
                    </v-flex>
                    <v-flex xs6>
                        {{`Nome: ${solicitacao.cliente.pessoa.nome} ${solicitacao.cliente.pessoa.sobrenome}`}}
                    </v-flex>
                    <v-flex xs6>
                        {{`CPF: ${solicitacao.cliente.pessoa.cpf}`}}
                    </v-flex>
                    <v-flex xs6>
                        {{`Telefone: ${solicitacao.cliente.pessoa.telefone}`}}
                    </v-flex>
                    <v-flex xs6 v-if="solicitacao.cliente.pessoa.data_nascimento">
                        {{`Data de Nascimento: ${solicitacao.cliente.pessoa.data_nascimento}`}}
                    </v-flex>
                    <v-flex xs6 v-if="solicitacao">
                        {{`Influenciador: ${solicitacao.influenciador ? 'SIM': 'NÃO'}`}}
                    </v-flex>
                    <v-flex xs6 v-if="solicitacao.influenciador">
                        Frentista: {{solicitacao.influenciador.frentista ? 'SIM' : 'NÃO'}}
                    </v-flex>
                    <v-flex xs12>
                        {{`E-mail: ${solicitacao.cliente.pessoa.email}`}}
                    </v-flex>
                    <v-flex xs12 class="mt-4">
                        Valor da solicitação:
                    </v-flex>
                    <v-flex xs12 class="text-xs-center primary--text">
                        <h2>{{formatar(solicitacao.valor)}}</h2>
                    </v-flex>
                    <v-flex xs12 class="mt-4">
                        Chave PIX: {{solicitacao.cliente.chave_pix}}
                    </v-flex>
                    <v-flex xs12 class="mt-3">
                        <v-btn block color="primary" @click="pagar">Pagar</v-btn>
                        <v-btn block class="mt-3" color="info" @click="dialog=true">Historico</v-btn>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </template>
        <template v-else-if="solicitacao.posto">
            <v-card-text>
                <v-layout fill-height wrap class="mb-3 subheading font-weight-regula" v-if="solicitacao">
                    <v-flex xs12 class="mb-2">
                        <h1 class="mt-2 mb-2 text-xs-center primary--text">Retirada de valor</h1>
                    </v-flex>
                    <v-flex xs6>
                        {{`Nome: ${solicitacao.posto.nome_fantasia}`}}
                    </v-flex>
                    <v-flex xs6>
                        {{`CNPJ: ${solicitacao.posto.cnpj}`}}
                    </v-flex>
                    <v-flex xs12 class="mt-4" v-if="solicitacao.posto.endereco">
                        Endereço: {{solicitacao.posto.endereco.logradouro}}, {{solicitacao.posto.endereco.numero}}, {{solicitacao.posto.endereco.bairro}} – {{solicitacao.posto.endereco.cidade}} – {{solicitacao.posto.endereco.estado}}. CEP {{solicitacao.posto.endereco.cep}}
                    </v-flex>
                    <v-flex xs12 class="mt-4">
                        Valor da solicitação:
                    </v-flex>
                    <v-flex xs12 class="text-xs-center primary--text">
                        <h2>{{formatar(solicitacao.valor)}}</h2>
                    </v-flex>
                    <v-flex xs12 class="mt-4">
                        Chave PIX: {{solicitacao.posto.chave_pix}}
                    </v-flex>
                    <v-flex xs12 class="mt-3">
                        <v-btn block color="primary" @click="pagar">Pagar</v-btn>
                        <v-btn block class="mt-3" color="info" @click="dialog=true">Historico</v-btn>
                    </v-flex>
                </v-layout>
        </v-card-text>
        <v-dialog v-model="dialog" v-if="dialog" width="500" scrollable>
            <historico-carteira :posto="solicitacao.posto" @fechar="dialog = false"/>
        </v-dialog>
        </template>
        <template v-else-if="solicitacao.empresa">
            <v-card-text>
                <v-layout fill-height wrap class="mb-3 subheading font-weight-regula" v-if="solicitacao">
                    <v-flex xs12 class="mb-2">
                        <h1 class="mt-2 mb-2 text-xs-center primary--text">Retirada de valor</h1>
                    </v-flex>
                    <v-flex xs6>
                        {{`Nome: ${solicitacao.empresa.nome_fantasia}`}}
                    </v-flex>
                    <v-flex xs6>
                        {{`CNPJ: ${solicitacao.empresa.cnpj}`}}
                    </v-flex>
                    <v-flex xs12 class="mt-4" v-if="solicitacao.empresa.endereco">
                        Endereço: {{solicitacao.empresa.endereco.logradouro}}, {{solicitacao.empresa.endereco.numero}}, {{solicitacao.empresa.endereco.bairro}} – {{solicitacao.empresa.endereco.cidade}} – {{solicitacao.empresa.endereco.estado}}. CEP {{solicitacao.empresa.endereco.cep}}
                    </v-flex>
                    <v-flex xs12 class="mt-4">
                        Valor da solicitação:
                    </v-flex>
                    <v-flex xs12 class="text-xs-center primary--text">
                        <h2>{{formatar(solicitacao.valor)}}</h2>
                    </v-flex>
                    <v-flex xs12 class="mt-4">
                        Chave PIX: {{solicitacao.empresa.chave_pix}}
                    </v-flex>
                    <v-flex xs12 class="mt-3">
                        <v-btn block color="primary" @click="pagar">Pagar</v-btn>
                        <v-btn block class="mt-3" color="info" @click="dialog=true">Historico</v-btn>
                    </v-flex>
                </v-layout>
        </v-card-text>
        </template>
        <v-dialog v-model="dialog" v-if="dialog" width="500" scrollable>
            <historico-carteira
                :posto="solicitacao.posto"
                :empresa="solicitacao.empresa"
                :pessoa="solicitacao.cliente ? solicitacao.cliente.pessoa : undefined"
                @fechar="dialog = false"
            />
        </v-dialog>
    </v-card>
</template>

<script>

import HistoricoCarteira from '@/components/dialogs/HistoricoCarteira'

export default {
  components: { HistoricoCarteira },
  props: ['solicitacao'],
  data: () => ({
    dialog: false
  }),
  methods: {
    formatar (valor) {
        return `R$ ${valor.replace('.', ',')}`
    },
    pagar () {
        this.$store.dispatch('marcarComoPago', { id: this.solicitacao.id }).then(() => {
            this.$emit('carregarNotificacoes')
            this.$emit('success', 'Cliente foi pago')
            this.$emit('fechar')
        })
    }
  }
}
</script>
